import { PopupAdapter, PopupCallback, PopupOptions } from './types';

export class Popup {
  private adapter: PopupAdapter;
  private visible: boolean;
  private priority: number;
  private id: string;
  private displayName: string;
  private onOpen?: PopupCallback;
  private onClose?: PopupCallback;
  private shown: boolean;

  constructor(adapter: PopupAdapter, options: PopupOptions) {
    this.adapter = adapter;
    this.id = options.id;
    this.displayName = options.displayName || options.id;
    this.visible = false;
    this.priority = options.priority ?? 0;
    this.onOpen = options.onOpen;
    this.onClose = options.onClose;
    this.shown = false;
  }

  async show(): Promise<boolean> {
    if (!this.visible) {
      if (await this.adapter.show()) {
        this.visible = true;
        this.shown = true;
        this.onOpen?.(this);
        return true;
      }
    }

    return false;
  }

  async hide(): Promise<boolean> {
    if (this.visible) {
      if (await this.adapter.hide()) {
        this.visible = false;
        this.onClose?.(this);
        return true;
      }
    }

    return false;
  }

  isVisible(): boolean {
    return this.visible;
  }

  getId(): string {
    return this.id;
  }

  getPriority(): number {
    return this.priority;
  }

  getDisplayName(): string {
    return this.displayName;
  }

  getShown(): boolean {
    return this.shown;
  }

  getAdapter(): PopupAdapter {
    return this.adapter;
  }
}

// @ts-ignore
window.Popup = Popup;
